import React, { useContext } from 'react';
import Typed from 'react-typed';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Section from '../common/Section';
import AppContext from '../../context/Context';
import bg1 from '../../assets/img/generic/condominium.jpg';
import dashboard     from './../../assets/img/generic/light.png';
import finance from '../../assets/img/generic/finance.png';
import financeLight from './../../assets/img/generic/financeLight.png';
import dashboardDark from './../../assets/img/generic/dark.png';

const Banner = () => {
  const { isDark } = useContext(AppContext);
  return  <>
            <Section className="py-0 overflow-hidden" image={bg1} position="center bottom" overlay>
              <Row className="justify-content-center align-items-center pt-8 pt-lg-10 pb-lg-9 pb-xl-0">
                <Col md={11} lg={8} xl={4} className="pb-7 pb-xl-9 text-center text-xl-left">
                  <h1 className="text-white font-weight-light">
                    <Typed
                      strings={['Gestiona', 'Organiza', 'Comunica', 'Disfruta']} 
                      typeSpeed={40} 
                      backSpeed={50} 
                      className="font-weight-bold" 
                      loop
                    />
                  </h1>
                  <p className="lead text-white opacity-75">
                  Homelan es una aplicación web orientada a llevar a cabo la gestión todos aquellos conjuntos de propiedades o establecimientos comerciales.  
                  </p>
                  <Link className="btn btn-outline-light border-2x rounded-pill btn-lg mt-4 fs-0 py-2" to="/register">
                    Registrate
                    <FontAwesomeIcon icon="play" transform="shrink-6 down-1 right-5" />
                  </Link>
                </Col>
                <Col xl={{ size: 7, offset: 1 }} className="align-self-center">
                  <div className="img-landing-banner">
                    <img className="img-fluid" src={isDark?financeLight:financeLight} alt="System" />
                  </div>
                </Col>
              </Row>
            </Section>
          </>
}

export default Banner;